import React from 'react';
import { Router, Link, hashHistory } from 'react-router';

import HardwareKeyboardArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

const Header = React.createClass({
	_logout: function() {
		hashHistory.push("/login");
		localStorage.removeItem('token');
	},
	render: function() {
		const style = {
			back: {
				color: '#fff',
				width: '35px',
				height: '35px',
				position: 'absolute',
				left: '5px',
				top: '8px',
				cursor: 'pointer',
			},
			more: {
				position: 'absolute',
				top: '0',
				right: '0',
			},
			icon: {
				fill: '#fff',
			}
		};

		if (this.props.home) {
			return (
				<header>
					<HardwareKeyboardArrowLeft onClick={hashHistory.goBack} style={style.back} />
					<h1>{this.props.headerTitle}</h1>
					<IconMenu
						iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
						anchorOrigin={{horizontal: 'right', vertical: 'top'}}
						targetOrigin={{horizontal: 'right', vertical: 'top'}}
						style={style.more}
						iconStyle={style.icon}
					>
						<MenuItem primaryText="Logout" onTouchTap={this._logout} />
					</IconMenu>
				</header>
			)
		} else {
			return (
				<header>
					<HardwareKeyboardArrowLeft onClick={hashHistory.goBack} style={style.back} />
					<h1>{this.props.headerTitle}</h1>
				</header>
			)
		}
	}
});

export default Header;


// WEBPACK FOOTER //
// ./src/components/header.jsx